import { withCompInfo } from '@wix/editor-elements-integrations'
import { PopupCloseIconButtonCSSVars, PopupCloseIconButtonDefinition } from './PopupCloseIconButton'
import { Overwrite } from '@wix/thunderbolt-becky-types'
import { colorApi } from '@wix/thunderbolt-becky-root'

export const css = withCompInfo<
	// TODO - Fix type once carmi code is removed
	Overwrite<PopupCloseIconButtonCSSVars, { 'z-index'?: number }>,
	PopupCloseIconButtonDefinition
>()(
	['hasResponsiveLayout', 'styleProperties', 'siteColors'],
	({ hasResponsiveLayout, styleProperties, siteColors }) => {
		const fillRawColor = styleProperties.fillcolor || siteColors[11]
		return {
			'--fill': colorApi.isThemeColor(fillRawColor)
				? colorApi.getRGBAColorString(colorApi.getFromColorMap(fillRawColor, siteColors), 1)
				: fillRawColor,
			'--fill-opacity': styleProperties['alpha-fillcolor'] ? parseFloat(styleProperties['alpha-fillcolor']) : 1,
			'--stroke': colorApi.getRGBAColorString(
				colorApi.getFromColorMap(styleProperties.stroke || 'color_15', siteColors),
				styleProperties['alpha-stroke'] ? parseFloat(styleProperties['alpha-stroke']) : 1
			),
			'--stroke-width': `${styleProperties.strokewidth || 1}${
				typeof styleProperties.strokewidth === 'string' && styleProperties.strokewidth.endsWith('px')
					? ''
					: 'px'
			}`,
			...(hasResponsiveLayout && {
				'z-index': 50,
			}),
		}
	}
)
